import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Image } from 'react-bootstrap';
import { FaGlobe, FaMapMarkerAlt } from 'react-icons/fa';
import qrJuan from '../img/qr-juan.png';
import qrYebrail from '../img/qr-yebrail.png';
import qrAndres from '../img/qr-andres.png';
import LogoSolo from '../img/LogoSolo.png';
import '../App.css';

const Footer = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    mensaje: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'mensaje' && value.length > 500) return;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { nombre, telefono, mensaje } = formData;

    if (!nombre || !telefono || !mensaje) {
      setError('Todos los campos son obligatorios');
      return;
    }

    setError('');
    setSubmitted(true);
    console.log('Formulario enviado:', formData);

    setTimeout(() => {
      setFormData({ nombre: '', telefono: '', mensaje: '' });
      setSubmitted(false);
    }, 5000);
  };

  return (
    <footer className="footer-container">
      <Container>
        <Row>
          {/* Columna izquierda - QRs */}
          <Col md={3} className="footer-contact text-center mb-4">
            <h5 className="footer-title">Contacto</h5>
            <div className="contact-person">
              <p><strong>Juan Arévalo</strong><br />Jarevalo@fdi.com.co</p>
              <Image src={qrJuan} alt="QR Juan Arévalo" className="qr-image" />
            </div>
            <div className="contact-person">
              <p><strong>Yebrail Leal</strong><br />Yleal@fdi.com.co</p>
              <Image src={qrYebrail} alt="QR Yebrail Leal" className="qr-image" />
            </div>
            <div className="contact-person">
              <p><strong>Andres Olarte</strong><br />Aolarte@fdi.com.co</p>
              <Image src={qrAndres} alt="QR Andres Olarte" className="qr-image" />
            </div>
          </Col>

          {/* Columna central - Info general */}
          <Col md={5} className="footer-info text-white mb-4">
            <div className="info-item">
              <FaGlobe className="info-icon text-danger" />
              <span><strong className="text-danger">www.fdi.com.co</strong></span>
            </div>
            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <span>Calle 74 #15-80 Oficina 716, Bogotá</span>
            </div>
            <Image src={LogoSolo} alt="LogoSolo" fluid className="mt-2" />
          </Col>

          {/* Columna derecha - Formulario */}
          <Col md={4} className="footer-form text-white mb-4">
            <h5 className="footer-title">Contáctanos</h5>
            <Form onSubmit={handleSubmit}>
              {error && <Alert variant="danger">{error}</Alert>}
              {submitted && <Alert variant="success">¡Gracias por tu mensaje!</Alert>}

              <Form.Group className="mb-2" controlId="formNombre">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Tu nombre"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-2" controlId="formTelefono">
                <Form.Label>Teléfono</Form.Label>
                <Form.Control
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  placeholder="Tu número de teléfono"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-2" controlId="formMensaje">
                <Form.Label>Mensaje</Form.Label>
                <Form.Control
                  as="textarea"
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleChange}
                  rows={3}
                  maxLength={500}
                  placeholder="Escribe tu mensaje"
                  required
                />
                <div className="text-end small">{formData.mensaje.length}/500</div>
              </Form.Group>

              <Button variant="danger" type="submit" disabled={submitted}>
                {submitted ? 'Enviado' : 'Enviar'}
              </Button>
            </Form>
          </Col>
        </Row>

        <hr className="border-light" />
        <p className="text-center copyright-text mb-0">
          © {new Date().getFullYear()} FDI. Todos los derechos reservados.
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
